export default "__VITE_ASSET__Drp0Cm4v__"